<template>
  <md-modal-dialog class="md-dialog" @md-opened="event = 'md-opened'" v-slot="{filterValue}">
    <ModalWrapper>
      <BudgetFilter :value="filterValue" :toggleState="filterValue" @change="onChange" @close="onModalClose" />
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import BudgetFilter from './budget-filter.vue';
import ModalWrapper from '@common/modal/simple-modal-wrapper.vue';

export default {
  name: 'time-picker-dialog',
  components: {
    ModalWrapper,
    BudgetFilter,
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    onChange(value) {
      this.value = value;
    },
    onModalClose() {
      this.$modal.submit(this.value);
    },
  },
};
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
}
</style>
